export const settings = {
  noImage: 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif',
  cartModal: {
    itemImageSize: '50x'
  },
  actionClasses: {
    hasItems: 'has-items',
    hidden: 'is-hidden',
    bodyClasses: 'is-drawer-open no-scroll',
    empty: 'is-empty',
    visible: 'is-visible',
    btnLoading: 'is-loading',
    btnAdded: 'form__btn--added'
  },
  selectors: {
    body: 'body',
    header: '.header',
    add: '.js-ajax-add',
    cartModal: '.js-cart-modal',
    cartCount: '.js-cart-count',
    cartClose: '.js-modal-close'
  },
  templates: {
    cartModal: Shopify.theme.templates.cart_modal,
    cartModalItem: Shopify.theme.templates.cart_modal_item
  },
};
